import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-4 text-ink font-display font-bold text-2xl md:text-4xl my-6" data-id="element-34">
      <div className="flex flex-col items-center" data-id="element-35">
        <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm min-w-[60px] md:min-w-[80px] text-center border border-sage/30" data-id="element-36">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <span className="text-xs uppercase mt-2 text-ink/60" data-id="element-37">Horas</span>
      </div>
      <span className="text-forest pb-6" data-id="element-38">:</span>
      <div className="flex flex-col items-center" data-id="element-39">
        <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm min-w-[60px] md:min-w-[80px] text-center border border-sage/30" data-id="element-40">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <span className="text-xs uppercase mt-2 text-ink/60" data-id="element-41">Min</span>
      </div>
      <span className="text-forest pb-6" data-id="element-42">:</span>
      <div className="flex flex-col items-center" data-id="element-43">
        <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm min-w-[60px] md:min-w-[80px] text-center border border-sage/30" data-id="element-44">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <span className="text-xs uppercase mt-2 text-ink/60" data-id="element-45">Seg</span>
      </div>
    </div>;
}